exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.report_detail td { text-align: left\n}\n.report_detail .v-text-field__details { display: none\n}\n", ""]);

// exports
